import "./AccountMenu.css";

export default function AccountMenu({ user={}, links=[], profileUrl="#", logoutUrl="#", roleLabel="", logoutLabel="Log Out" }) {
  const initial = (user.displayName||"?").trim().charAt(0).toUpperCase();
  return (
    <div className="gnb-menu-card am-card" style={{width:240}}>
      <a className="am-head" href={profileUrl}>
        <span className="am-avatar">{user.profilePicture ? <img src={user.profilePicture} alt="" /> : initial}</span>
        <span className="am-id"><span className="am-name">{user.displayName}</span><span className="am-role">{roleLabel}</span></span>
        <i className="pi pi-chevron-right am-arrow" />
      </a>
      <div className="am-divider" />
      {links.map((l,i)=>(<a key={l.route} className="am-link" href={l.route}>{l.name}</a>))}
      <div className="am-divider" />
      <a className="am-link am-logout" href={logoutUrl}>{logoutLabel}</a>
    </div>
  );
}
